import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "view-tenant-review-header w-100 d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center view-tenant-review-content w-100" }
const _hoisted_3 = { class: "profile-info w-100" }
const _hoisted_4 = { class: "d-flex align-items-center rating" }
const _hoisted_5 = { class: "name mb-0 text-capitalize" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_7 = { class: "fs-5 fw-bolder rating-text" }
const _hoisted_8 = { class: "text-normal" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_10 = { class: "d-flex align-items-center other-details justify-content-between w-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center type" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-user icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Tenant")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center phone"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1)
const _hoisted_14 = { class: "text" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "d-flex align-items-center mail" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope icon" }, null, -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "d-flex align-items-center date" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Signed up date: ")
const _hoisted_23 = { class: "d-flex align-items-center date" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Last Login date: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Avatar, {
        size: 64,
        imageFile: _ctx.tenantAvatarSrc,
        acronym: _ctx.tenantAcronym,
        useIcon: false,
        fontSize: `2em`
      }, null, 8, ["imageFile", "acronym"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.info.first_name) + " " + _toDisplayString(_ctx.info.last_name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, { class: "mb-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_rate, {
                  disabled: "",
                  size: "small",
                  class: "rating-size",
                  "model-value": (_ctx.info || { average_rating: 0 })?.average_rating
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString((_ctx.info || { average_rating: 0 })?.average_rating?.toFixed(1)) + "/5.0 (", 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString((_ctx.info || { submitted_reference_count: 0 })
                    ?.submitted_reference_count) + " reviews", 1),
              _hoisted_9
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          (_ctx.info.mobile_number)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, [
                  _createElementVNode("a", {
                    href: `tel: ${_ctx.info.mobile_number}`
                  }, _toDisplayString(_ctx.info.mobile_number || 'Not Specified'), 9, _hoisted_15)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("a", {
                href: `mailto: ${_ctx.info.email}`
              }, _toDisplayString(_ctx.info.email || 'Not Specified'), 9, _hoisted_19)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.formatDate(_ctx.info.signup_date, 'aus')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("strong", null, _toDisplayString(_ctx.lastLoggedInDate), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}